<template>
    <div>
        <div class="arrow-up"></div> 

        <v-card class="content">
            <v-card-text>
                <span class="no-reports" v-if="!backgroundReportsMetaList.length">No reports queued</span>
                <v-list v-if="backgroundReportsMetaList.length">
                    <template v-for="(backgroundReportMeta, index) in backgroundReportsMetaList">
                        <v-list-item :key="backgroundReportMeta.timeId" style="padding: 0px;">
                            <div class="report-container" :class="{'no-padding-top': (index == 0)}">
                                <v-btn @click="removeReport(backgroundReportMeta)" icon x-small class="remove-report-button"><v-icon>mdi-close</v-icon></v-btn>
                                <span class="report-title">{{ backgroundReportMeta.reportParamObj.report }} <v-icon small color="#c42111" v-if="backgroundReportMeta.reportParamObj.email">mdi-email</v-icon></span>
                                <span class="report-info">{{ `Ran at: ${formatTime(backgroundReportMeta.timeId)}` }}</span>
                                <div class="report-status">
                                    <v-icon class="mt-5 mr-1" v-if="backgroundReportMeta.running">fas fa-spinner fa-spin</v-icon>
                                    <v-btn @click="viewResults(backgroundReportMeta)" fab x-small class="mt-4" color="#c42111" v-if="!backgroundReportMeta.running && backgroundReportMeta.reportResultParamsHash"><v-icon>mdi-table</v-icon></v-btn>
                                    <v-btn @click="downloadFile(backgroundReportMeta)" fab x-small class="mt-4" color="#c42111" v-if="!backgroundReportMeta.running && backgroundReportMeta.reportResultFileName"><v-icon>mdi-file</v-icon></v-btn>
                                    <v-icon class="mt-5 mr-1" color="#DC3545" v-if="!backgroundReportMeta.running && backgroundReportMeta.error">mdi-alert</v-icon>
                                </div>
                            </div>
                        </v-list-item>
                        <v-divider v-if="backgroundReportsMetaList.length > 1" />
                    </template>
                </v-list>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'BackgroundReportsSummary',
    data: () => ({
    }),

    computed: {
        backgroundReportsMetaList: function() {
            let metaList = this.$store.state.backgroundReports;
            metaList.sort((a,b) => {return b.timeId - a.timeId;});
            return metaList;
        }
    },

    methods: {
        formatTime: function(unixTime) {
            return TELSA.moment(unixTime).format("HH:mm:ss");
        },

        viewResults: function(backgroundReportMeta) {
            this.$emit('close');
            let route = (TELSA.apiHost + "report/history/result");
            TELSA.loading(true);
            return this.$http.post(route, {args: {report_name: backgroundReportMeta.reportParamObj.report, params_hash: backgroundReportMeta.reportResultParamsHash}}).then(response => {
                let results = response.body;
                backgroundReportMeta.results = results;
                this.$store.commit('setBackgroundReportShortcut', backgroundReportMeta);
                if(this.$route.name != 'reporthistory') {
                    this.$router.push('reporthistory');
                }
            });
        },

        downloadFile: function(backgroundReportMeta) {
            this.$emit('close');
            let dlink = document.createElement('a');
            dlink.setAttribute("id", "report-download-file-link-hidden");
            let url = new URL(`${TELSA.staticHost}${backgroundReportMeta.reportResultFileName}?prettyname=${backgroundReportMeta.reportResultPrettyFileName}`);
            dlink.href = url;
            dlink.click();
            dlink.remove();
        },

        removeReport: function(backgroundReportMeta) {
            this.$store.state.backgroundReports.splice(this.$store.state.backgroundReports.findIndex(br => br.timeId == backgroundReportMeta.timeId), 1);
        }
    },

    mounted() {
    }
};
</script>

<style scoped>

    .content {
        width: 450px;
        max-height: 400px; overflow-y: auto;
    }

    .arrow-up {
        width: 0; 
        height: 0; 
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: relative;
        left: calc(50% - (10px / 2));
        top: 0px;
        border-bottom: 10px solid #424242;
        z-index: 10;
    }

    @media(max-width: 600px) {
        .arrow-up {
            left: 55px;
        }
    }

    .no-reports {
        margin-left: calc(50% - (150px / 2));
        font-size: 18px;
    }

    .report-container {
        display: block;
        width: 100%;
        padding: 10px 0px 10px 5px;   
        margin-left: 30px;
    }
    .report-container:hover {
        background-color: #595959;
    }
    .report-container.no-padding-top {
        /* padding-top: 0px; */
    }

    .report-container .remove-report-button {
        display: block;
        position: absolute;
        top: 20px;
        left: 0px;
    }

    .report-container .report-title {
        color: #ffffff;
        font-size: 15px;
        font-weight: bold;
        display: block;
    }
    .report-container .report-info {
        font-size: 12px;
        display: block;
    }

    .report-container .report-status {
        position: absolute;
        right: 10px;
        top: 0px;
    }

</style>
